export default "__VITE_ASSET__ALk2mg1j__"